import { ENV_VARIABLES } from "../Config/env-config";
export const initializeMocks = async () => {
  if (ENV_VARIABLES.REACT_APP_USE_MOCKS === "true") {
    try {
      const { mswWorker } = await import("./mswWorker");
      await mswWorker.start({
        serviceWorker: {
          url: "/mockServiceWorker.js", // in public folder
        },
        // quiet: true //This stops some of the console logs from MSW
      });
      console.log("MSW Worker started");
    } catch (error) {
      console.error("Failed to start MSW Worker", error);
    }
  }
};

// To turn this on and off check .env file.
